import { render, staticRenderFns } from "./TermsOfService2.vue?vue&type=template&id=39c243da&"
import script from "./TermsOfService2.vue?vue&type=script&lang=js&"
export * from "./TermsOfService2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports